module.exports = __webpack_public_path__ + "static/media/ABOUT2.73924eba.jpg";